import { render, staticRenderFns } from "./SubmitOtherDialog.vue?vue&type=template&id=06f0aa3c&scoped=true"
import script from "./SubmitOtherDialog.vue?vue&type=script&lang=js"
export * from "./SubmitOtherDialog.vue?vue&type=script&lang=js"
import style0 from "./SubmitOtherDialog.vue?vue&type=style&index=0&id=06f0aa3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0aa3c",
  null
  
)

export default component.exports